import { useNavigate, useOutletContext } from 'react-router-dom';

import Button from 'primitives/Button';

import { formatCurrency } from 'utils/format-helper';

const BasketsSuccessStep = () => {
  const { basketSummary } = useOutletContext<any>();

  const navigate = useNavigate();

  if (!basketSummary) return null;

  return (
    <section className="space-y-6">
      <header className="space-y-2 flex flex-row justify-between items-center">
        <div>
          <h2 className="text-3xl font-semibold text-slate-900">Commitment Successful!</h2>
          <p className="text-slate-500">
            Your investment commitment has been confirmed across all selected deals.
          </p>
        </div>
        <div className="flex flex-col items-center">
          <div className="rounded-full bg-emerald-100 text-emerald-600 w-14 h-14 flex items-center justify-center">
            <span className="text-2xl">✓</span>
          </div>
          <p className="text-sm text-emerald-600 font-semibold uppercase tracking-wide">
            Committed
          </p>
        </div>
      </header>
      <div className="rounded-3xl bg-white shadow-sm border border-slate-100 divide-y divide-slate-100">
        {basketSummary.closings.map(closing => (
          <div key={closing.id} className="flex items-center justify-between px-6 py-4">
            <div>
              <p className="font-medium text-slate-900">
                {closing.deal.companyInformation.company.name}
              </p>
              <p className="text-sm text-emerald-600 font-semibold">COMMITTED</p>
            </div>
            <p className="text-base font-semibold text-slate-900">
              {formatCurrency(closing.amount)}
            </p>
          </div>
        ))}
        <div className="px-6 py-4 flex items-center justify-between">
          <p className="text-base font-semibold text-slate-900">Total Commitment</p>
          <p className="text-lg font-semibold text-slate-900">
            {formatCurrency(
              basketSummary.closings.reduce((sum, closing) => sum + closing.amount, 0)
            )}
          </p>
        </div>
      </div>
      <div className="rounded-2xl border border-indigo-100 bg-indigo-50 px-6 py-5 space-y-3">
        <p className="text-base font-semibold text-indigo-900">What’s Next?</p>
        <p className="text-sm text-indigo-800">
          Please stand by until the companies initiate the wiring stage. You will receive wiring
          instructions via email once the companies are ready to accept funds.
        </p>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button
          variant="primary"
          className="flex-1 px-4 py-3 "
          onClick={() => navigate('/invest/baskets')}
        >
          View Cases
        </Button>
      </div>
    </section>
  );
};

export default BasketsSuccessStep;
